import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { useEffect, useRef, useState } from 'react';
import { getAllDetailsDirect, postAllData } from '../../service/ProductService';
import { APP_HOSPITAL, SCRUTINY_VERIFICATION, SCRUTINY_VERIFICATION_UPDATE } from '../../config/ApiConstant';
import { Checkbox } from 'primereact/checkbox';
import { verificationChoiceData } from '../../appconfig/Settings';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { VerificationValidation } from '../../config/Validate';

const ScrutinyVerificationModal = (props: any) => {
    const toast = useRef<any>(null);


    const { dismissClick, openmodel,  data } = props;

    const [holdBtnSpinner, setHoldBtnSpinner] = useState<boolean>(false);
    const [selected, setSelected] = useState<any>([]);

    const [errors, setErrors] = useState<any>({});
    const [uploadData, setUploadData] = useState<any>({});
    const [hospitalsList, setHospitalsList] = useState<any>([]);

    const [selectedHospital, setSelectedHospital] = useState<any>(null);

    useEffect(() => {
        getAllHospital();
    }, []);

    // Get all hospital
    const getAllHospital = async () => {
        try {
            const response = await getAllDetailsDirect(APP_HOSPITAL + '?type=all');
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setHospitalsList([]);
                } else {
                    let hospitalData = [];
                    for (let i = 0; i < DataList.length; i++) {
                        const hospitalObj: any = {};
                        hospitalObj['name'] = DataList[i].HospName;
                        hospitalObj['code'] = DataList[i].HospNo;
                        hospitalData.push(hospitalObj);
                    }
                    setHospitalsList(hospitalData);
                }
            } else {
                setHospitalsList([]);
            }
        } catch (error: any) {
            setHospitalsList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // User Data
    let userData = !window.cn(data?.applicationDetails) ? data?.applicationDetails : '';

    const addUploadReply = async () => {
        try {
            const { errors, isError } = VerificationValidation(uploadData);

            setErrors(errors);

            if (!isError) {
                setHoldBtnSpinner(true);
                // Get Data
                const { fileNo, freshApplicationNo, freshApplicationName } = data;

                // Get User Name from LocalStorage
                const userName: any = localStorage.getItem('name');

                // Create Object
                let verificationObj: any = {};

                if (selected.some((item: any) => item.key === 'School')) {
                    verificationObj.School = userData?.HSCSNm;
                }

                if (selected.some((item: any) => item.key === 'Board')) {
                    verificationObj.Board = userData?.HSCBrd;
                }

                if (selected.some((item: any) => item.key === 'College')) {
                    verificationObj.College = userData?.ColName;
                }
                if (selected.some((item: any) => item.key === 'Univeristy')) {
                    verificationObj.Univeristy = userData?.collagemaster?.university;
                }
                if (selected.some((item: any) => item.key === 'Council')) {
                    verificationObj.Council = userData?.TRCounCilNm;
                }
                if (selected.some((item: any) => item.key === 'Practical Training Center')) {
                    verificationObj.PracticalTraining = selectedHospital?.name;
                }
                if (selected.some((item: any) => item.key === 'Other')) {
                    verificationObj.other_field = uploadData?.verificationOther;
                }

                // Request Data
                let formData = new FormData();
                formData.append('SrNo', atob(fileNo));
                formData.append('AppId', freshApplicationNo);
                formData.append('AppName', freshApplicationName);
                formData.append('verification_by', userName);
                formData.append('verification_to', JSON.stringify(verificationObj));
                formData.append('comment', uploadData?.verificationNote);

                if (!window.cn(uploadData?.photo)) {
                    formData.append('file_url', uploadData?.photo); 
                }

                // Api Call
                const response = await postAllData(SCRUTINY_VERIFICATION, formData);

                if (response) {
                    toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.message });

                    setHoldBtnSpinner(false);
                    clearAll();
                }
            }
        } catch (error: any) {
            if (error.response) {
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });

                setHoldBtnSpinner(false);

                clearAll();
            }
        }
    };

    //on input change event
    const onInputChange = (e: any, name: string) => {
        let val;
        if (name === 'photo') {
            val = e.target.files[0] || '';
        } else {
            val = (e.target && e.target.value) || e.value || '';
        }

        setUploadData({ ...uploadData, [name]: val });
    };

    //checkboxchange
    const onVerificationChange = (e: any) => {
        let _selectedCategories: any = [...selected];

        if (e.checked) _selectedCategories.push(e.value);
        else _selectedCategories = _selectedCategories.filter((category: any) => category.key !== e.value.key);

        setSelected(_selectedCategories);
    };

    // Close And Clear
    const clearAll = () => {
        dismissClick();
        setSelected([]);
        setSelectedHospital(null);
        setUploadData({});
    };

    

    return (
        <>
            <Toast ref={toast} />

            <Dialog
                visible={openmodel}
                className="p-fluid"
                style={{ width: '700px' }}
                header="Verification"
                modal
                draggable={false}
                resizable={false}
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={() => clearAll()} />
                        <Button label="Submit" icon="pi pi-check" onClick={() => addUploadReply()} loading={holdBtnSpinner} />
                    </>
                }
                onHide={() => clearAll()}
            >
                <div className="p-fluid formgrid grid">
                    <div className="field col-12">
                        <label htmlFor="Verification Note">
                            Verification Note <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className="input-effect-div">
                            <InputText
                                value={uploadData?.verificationNote}
                                name="verificationNote"
                                autoComplete="off"
                                placeholder="Enter Verification Note"
                                onChange={(e) => onInputChange(e, 'verificationNote')}
                                className={errors['verificationNote'] && 'p-invalid'}
                            />
                        </div>
                        <small className="p-invalid-txt">{errors['verificationNote']}</small>
                    </div>
                    <div className="field col-12 grid">
                        <div className="field col-12 md:col-6">
                            <label htmlFor="photo">Verification To</label>

                            <div className="mt-2">
                                {verificationChoiceData.map((category: any) => {
                                    return (
                                        <div key={category.key} className="flex align-items-center mb-2">
                                            <Checkbox inputId={category.key} name="category" value={category} onChange={onVerificationChange} checked={selected.some((item: any) => item.key === category.key)} />
                                            <label htmlFor={category.key} className="ml-2">
                                                {category.name}
                                                {/* {selected.some((item: any) => item.key === category.key) ?  } */}
                                            </label>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        <div className="field col-12 md:col-6 mt-2">
                            <div className="mt-4"></div>

                            <div className="mb-2" style={{ minHeight: '20px' }}>
                                {selected.some((item: any) => item.key === 'School') ? !window.cn(userData?.HSCSNm) ? userData?.HSCSNm : '' : <div className="mb-2"></div>}
                            </div>
                            <div className="mb-2" style={{ minHeight: '20px' }}>
                                {selected.some((item: any) => item.key === 'Board') ? !window.cn(userData?.HSCBrd) ? userData?.HSCBrd : '' : <div className="mb-2"></div>}
                            </div>
                            <div className="mb-2" style={{ minHeight: '20px' }}>
                                {selected.some((item: any) => item.key === 'College') ? !window.cn(userData?.ColName) ? userData?.ColName : '' : <div className="mb-2"></div>}
                            </div>
                            <div className="mb-2" style={{ minHeight: '20px' }}>
                                {selected.some((item: any) => item.key === 'University') ? !window.cn(userData?.collagemaster?.university) ? userData?.collagemaster?.university : '' : <div className="mb-2"></div>}
                            </div>
                            <div className="mb-2" style={{ minHeight: '20px' }}>
                                {selected.some((item: any) => item.key === 'Council') ? !window.cn(userData?.TRCounCilNm) ? userData?.TRCounCilNm : '' : <div className="mb-2"></div>}
                            </div>
                        </div>
                    </div>

                    {selected.some((item: any) => item.key === 'Practical Training Center') && (
                        <div className="field col-12">
                            <label htmlFor="Hospital">
                                Hospital <span style={{ color: 'red' }}>*</span>
                            </label>
                            <div className="input-effect-div">
                                <Dropdown
                                    value={selectedHospital}
                                    name="selectedHospital"
                                    options={hospitalsList}
                                    filter
                                    optionLabel="name"
                                    placeholder="Select Hospital"
                                    onChange={(e) => setSelectedHospital(e.value)}
                                    className={errors['selectedHospital'] && 'p-invalid'}
                                />
                                <span className="focus-bg"></span>
                            </div>
                            <small className="p-invalid-txt">{errors['selectedHospital']}</small>
                        </div>
                    )}

                    {selected.some((item: any) => item.key === 'Other') && (
                        <div className="field col-12">
                            <label htmlFor="Other">
                                Other <span style={{ color: 'red' }}>*</span>
                            </label>
                            <div className="input-effect-div">
                                <InputText
                                    value={uploadData?.verificationOther}
                                    name="verificationOther"
                                    autoComplete="off"
                                    placeholder="Other"
                                    onChange={(e) => onInputChange(e, 'verificationOther')}
                                    className={errors['verificationOther'] && 'p-invalid'}
                                />
                            </div>
                            <small className="p-invalid-txt">{errors['verificationOther']}</small>
                        </div>
                    )}

                    <div className="field col-12 md:col-12">
                        <label htmlFor="photo">Verification File *</label>
                        <div className="upload-box">
                            <i className="pi pi-upload" style={{ fontSize: '1.2rem', marginRight: '0.5rem' }}></i>
                            <span>Verification File</span>
                            <input type="file" id="fileInput" accept=" application/pdf" onChange={(e) => onInputChange(e, 'photo')} className="file-input" />
                        </div>

                        {uploadData?.photo && (
                            <div className="file-preview">
                                <div className="file-info">
                                    <a href={URL.createObjectURL(uploadData?.photo)} target="_blank" rel="noopener noreferrer" className="file-name">
                                        {uploadData?.photo.name}
                                    </a>
                                    <span className="file-details">
                                        {uploadData?.photo.type} &nbsp;♦&nbsp; {(uploadData?.photo.size / 1024).toFixed(2)} KB
                                    </span>
                                </div>
                            </div>
                        )}

                        <small className="p-invalid-txt">{errors['photo']}</small>
                    </div>
                </div>
            </Dialog>
        </>
    );
};
export default ScrutinyVerificationModal;
